/**
 * 로딩 다이얼로그를 띄운다.
 * @param open true: 열기, false: 닫기
 * @param num 현재 진행된 개수
 * @param total 전체 개수
 * @param unit 단위
 */
export function loading(open = false, num = 0, total = 0, unit = "") {
  const loadingDialog = new CustomEvent("loadingDialog", {
    detail: {
      open,
      num,
      total,
      unit
    },
  });
  window.dispatchEvent(loadingDialog);
}

/**
 * 알림 다이얼로그를 띄운다. 브라우저 기본 alert() 대신 사용한다.
 * 기본 alert() 와 달리 화면을 멈추지 않으므로, 닫힌 뒤에 해야 할 일(페이지 이동 등)이 있으면 await 한다.
 *
 * @param {String} message 표시할 문구 (줄바꿈 \n 유지, HTML 은 해석하지 않음)
 * @param {Object} [options]
 * @param {String} [options.title] 제목 (기본: 알림)
 * @param {String} [options.closeBtn] 닫기 버튼 문구 (기본: 확인)
 * @returns {Promise<void>} 다이얼로그가 닫히면 resolve
 */
export function alertDialog(message, options = {}) {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent("customAlert", {
      detail: {
        title: options.title || "알림",
        message: `${message}`,
        cancelBtn: options.closeBtn || "확인",
        plain: true,
        onSettle: () => resolve(),
      },
    }));
  });
}

/**
 * 확인 다이얼로그를 띄운다. 브라우저 기본 confirm() 대신 사용한다.
 * 닫기(X)나 바깥 영역 클릭으로 닫으면 취소(false)로 처리한다.
 *
 * @param {String} message 표시할 문구 (줄바꿈 \n 유지, HTML 은 해석하지 않음)
 * @param {Object} [options]
 * @param {String} [options.title] 제목 (기본: 확인)
 * @param {String} [options.confirmBtn] 확인 버튼 문구 (기본: 확인)
 * @param {String} [options.cancelBtn] 취소 버튼 문구 (기본: 취소)
 * @returns {Promise<boolean>} 확인 버튼을 누르면 true
 */
export function confirmDialog(message, options = {}) {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent("customAlert", {
      detail: {
        title: options.title || "확인",
        message: `${message}`,
        useConfirm: true,
        confirmBtn: options.confirmBtn || "확인",
        cancelBtn: options.cancelBtn || "취소",
        plain: true,
        onSettle: (result) => resolve(!!result),
      },
    }));
  });
}
